var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoomPlaceholder = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 48,
  viewBox: "0 0 44 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 0L6 4L10 8L14 4L10 0ZM14 4L18 8L22 4L18 0L14 4ZM22 4L26 8L30 4L26 0L22 4ZM30 4L34 8L38 4L34 0L30 4ZM34 8H0V48H44V8H34ZM4 12H40V44H28V34H16V44H4V12ZM8 16V20H12V16H8ZM16 16V20H20V16H16ZM24 16V20H28V16H24ZM32 16V20H36V16H32ZM8 22V26H12V22H8ZM16 22V26H20V22H16ZM24 22V26H28V22H24ZM32 22V26H36V22H32ZM8 28V32H12V28H8ZM16 28V32H20V28H16ZM24 28V32H28V28H24ZM32 28V32H36V28H32ZM8 34V38H12V34H8ZM32 34V38H36V34H32ZM20 38H24V44H20V38Z",
  fill: "black",
  fillOpacity: 0.2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoomPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/room-placeholder.bd629d2635b4c652f1bce9d2538f3dbc.svg";